import { useWidgetStore } from "../stores/widget-store";
import { i18n } from "@/i18n";
import { Label } from "@/components/ui/label";

const SIZES = [
  { label: () => i18n.__( 'Small', 'accessibility-widget' ), value: 32 },
  { label: () => i18n.__( 'Medium', 'accessibility-widget' ), value: 48 },
  { label: () => i18n.__( 'Large', 'accessibility-widget' ), value: 64 },
];

export function SizeSelector() {
  const iconSize = useWidgetStore((state) => state.config.iconSize);
  const setIconSize = useWidgetStore((state) => state.setIconSize);
  return (
    <div className="cy:space-y-3">
      <div className="cy:flex cy:items-center cy:space-x-2">
        <Label>{i18n.__( 'Size', 'accessibility-widget' )}</Label>
      </div>
      <div className="cy:flex-1 cy:space-x-2">
        {SIZES.map((size) => (
          <button
            key={size.value}
            onClick={() => setIconSize(size.value)}
            className={`cy:h-[48px] cy:flex-1 cy:justify-items-center cy:border-1 cy:rounded-md cy:transition-all cy:px-3 ${
              iconSize === size.value
                ? "cy:border-blue-500 cy:bg-blue-50"
                : "cy:border-gray-200 cy:hover:border-gray-300 cy:hover:cy:border-gray-300"
            }`}
          >
            {getSizeLabel(size.value)}
          </button>
        ))}
      </div>
    </div>
  );
}

function getSizeLabel(pixelValue: number) {
  const found = SIZES.find((size) => size.value === pixelValue);
  return found ? found.label() : pixelValue + "px";
}
